import React from 'react';

// Keep failures visible after transient toasts disappear, including 403 plan/profile gates.
const RequestError = ({ message, testId }) => message ? (
  <p role="alert" data-testid={testId}
    className="my-3 rounded-lg border border-red-200 bg-red-50 px-4 py-3 text-sm text-red-800">
    {message}
  </p>
) : null;

export default RequestError;
